import type { StateCreator } from 'zustand';

export interface MonitoringTourSliceState {
  stepsIndex: number;
  progressBar: boolean;
  progressBarTitle: string;
  onboardingStepName: string;
  progressBarTourStepsTotal: number;
  monitoringTour: boolean;
  monitoringGeofenceTour: boolean;
  monitoringGeofenceTourModal: boolean;
  setProgressBar: (progressBar: boolean) => void;
  setStepsIndex: (value: number) => void;
  setMonitoringTour: (setMonitoringTour: boolean) => void;
  setMonitoringGeofenceTour: (geofenceTour: boolean) => void;
  setMonitoringGeofenceTourModal: (geofenceTourModal: boolean) => void;
  setMonitoringGeofenceTourStart: () => void;
  setMonitoringGeofenceTourFinish: () => void;
}

type StateCreatorMonitoringTour = StateCreator<MonitoringTourSliceState>;

const initialStates = {
  stepsIndex: 0,
  progressBar: false,
  progressBarTitle: 'Cadastre locais de interesse no painel',
  onboardingStepName: '',
  progressBarTourStepsTotal: 0,
  monitoringTour: false,
  monitoringGeofenceTour: false,
  monitoringGeofenceTourModal: false,
};

const createMonitoringTourSlice: StateCreatorMonitoringTour = (set) => ({
  ...initialStates,
  setProgressBar: (progressBar: boolean) => set({ progressBar }),
  setStepsIndex: (stepsIndex: number) => set({ stepsIndex }),
  setMonitoringTour: (monitoringTour: boolean) => set({ monitoringTour }),
  setMonitoringGeofenceTour: (monitoringGeofenceTour: boolean) => set({ monitoringGeofenceTour }),
  setMonitoringGeofenceTourModal: (monitoringGeofenceTourModal: boolean) => set({ monitoringGeofenceTourModal }),
  setMonitoringGeofenceTourStart: () =>
    set({
      ...initialStates,
      progressBar: true,
      onboardingStepName: 'Monitoring',
      progressBarTourStepsTotal: 14,
      monitoringTour: true,
      monitoringGeofenceTourModal: false,
      monitoringGeofenceTour: false,
    }),
  setMonitoringGeofenceTourFinish: () =>
    set({
      ...initialStates,
      progressBar: true,
    }),
});

export default createMonitoringTourSlice;
